import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class PluginHelperService {
  isNative() {
    return Capacitor.isNativePlatform();
  }
}
